import React from "react";
import { Card, Empty, Space, Row, Col } from "antd";
import SourceViewer from "../../components/SourceViewer";
import { useSource } from "../../hooks/useSource";
import PageHeader from "../../components/common/PageHeader";

/**
 * Página de monitoramento de fontes.
 *
 * Exibe todas as fontes que estão sendo buscadas.
 */
const GetIdDemandMonitoringContent: React.FC = () => {
  const { sources } = useSource();

  return (
    <Card>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <PageHeader title="Monitoramento de Fontes" />

        {sources.length === 0 ? (
          <Empty 
            description="Nenhuma fonte sendo monitorada. Volte para a página de Buscar Fonte para adicionar." 
            image={Empty.PRESENTED_IMAGE_SIMPLE} 
          />
        ) : (
          <Row gutter={[16, 16]}>
            {sources.map((sourceId, idx) => (
              <Col xs={24} sm={24} md={12} lg={12} xl={12} key={idx}>
                <SourceViewer sourceId={sourceId} />
              </Col>
            ))}
          </Row>
        )}
      </Space>
    </Card>
  );
};

/**
 * Componente principal da página GetIdDemandMonitoring.
 */
const GetIdDemandMonitoring: React.FC = () => {
  return (
    <GetIdDemandMonitoringContent />
  );
};

export default GetIdDemandMonitoring;

